import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from "@/components/ui/select";
import type { PagedResult } from "@/lib/clients-accounts";

export interface DeliveryMethodDto {
  id: number;
  delCode: string;
  description: string;
  displayOnClientSite: boolean;
  clientInfoMsg: string | null;
  deleted: boolean;
}

export interface DeliveryMethodPickerProps {
  value: number | null;
  onChange: (methodId: number | null) => void;
  placeholder?: string;
  disabled?: boolean;
}

export function DeliveryMethodPicker({
  value,
  onChange,
  placeholder,
  disabled,
}: DeliveryMethodPickerProps) {
  const { data, isLoading } = useQuery({
    queryKey: ["delivery-methods"],
    queryFn: () => apiFetch<PagedResult<DeliveryMethodDto>>("/api/lookups/delivery-methods"),
    select: (result) => result.items,
    staleTime: 60_000,
  });

  const items = data ?? [];

  return (
    <Select
      value={value !== null ? String(value) : undefined}
      onValueChange={(v) => onChange(v === "__none__" ? null : Number(v))}
      disabled={disabled}
    >
      <SelectTrigger>
        <SelectValue
          placeholder={isLoading ? "Loading…" : (placeholder ?? "Select delivery method")}
        />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="__none__">(none)</SelectItem>
        {items.map((m) => (
          <SelectItem key={m.id} value={String(m.id)}>
            {m.description}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
